// extracted by mini-css-extract-plugin
module.exports = {"button":"Button_button__3QF_k constants_colors__2ZDH7 constants_fonts__FFeIK"};